import React from 'react';
import { useState, useEffect } from 'react';
import { observer } from 'mobx-react-lite';

import { makeStyles } from '@material-ui/core/styles';
import Modal from '@material-ui/core/Modal';
import Backdrop from '@material-ui/core/Backdrop';
import Fade from '@material-ui/core/Fade';
import Draggable from "react-draggable";

import { useStore } from '../../stores';

const useStyles = makeStyles(() => ({
  modal: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  }
}));

const RenameFile = observer(() => {
  const { viewStore, fileActionStore, searchStore } = useStore();
  const [inputFolder, setInputFolder] = useState('');
  const classes = useStyles();

  const info = fileActionStore.info;
  const modalTitle = 'Đổi tên ' + (info.type ? 'file' : 'folder');
  const openModal = fileActionStore.isShowRename;

  useEffect(() => {
    if (openModal) {
      setInputFolder(info.displayName);
    }
  }, [openModal, info])

  const handleCloseModal = (e) => {
    e.preventDefault();

    fileActionStore.setShowModal('Rename', false)
  };

  const handleKeyDown = (event) => {
    if (event.key === 'Enter' && inputFolder.length) {
      handleClickSubmit(event);
    }
  }

  const handleClickSubmit = async (e) => {
    const resultSubmit = await fileActionStore.handleSubmitRename(inputFolder);

    if (resultSubmit && resultSubmit.success) {
      handleCloseModal(e);
      if (searchStore.isSearch) searchStore.setAfterSearch(true)
      viewStore.enableRefreshList();
      viewStore.enableRefreshCurrentInfo();
    }
  }

  return (
    <div className="nk-fmg-actions" style={{ paddingBottom: '5px' }}>
      <ul className="nk-block-tools g-3">
        <Modal
          aria-labelledby="transition-modal-title"
          aria-describedby="transition-modal-description"
          className={classes.modal}
          open={openModal}
          onClose={handleCloseModal}
          closeAfterTransition
          BackdropComponent={Backdrop}
          BackdropProps={{
            timeout: 500,
          }}
        >
          <Draggable
            onDrag={(e) => { e.preventDefault(); }}
            bounds="parent"
            handle=".modal-header"
            cancel=".close"
          >
            <Fade in={openModal}>
              <div style={{ width: '500px' }} tabIndex="-1" role="dialog" id="file-copy" aria-modal="true">
                <div className="modal-dialog modal-md" role="document">
                  <div className="modal-content">
                    <div className="modal-header align-center border-bottom-0">
                      <h5 className="modal-title">{modalTitle}</h5>
                      <a href="# " className="close" style={{ cursor: 'pointer' }} onClick={handleCloseModal}>
                        <em className="icon ni ni-cross-sm"></em>
                      </a>
                    </div>
                    <div className="modal-body pt-0 mt-n2">
                      <div className="nk-file-share-input nk-file-share-input-to" style={{ border: '1px solid #ccc', marginTop: '10px' }}>
                        <input
                          type="text"
                          className="input-mail tagify"
                          style={{ padding: '8px' }}
                          placeholder="Nhập tên"
                          value={inputFolder}
                          ref={el => { if (el) el.focus(); }}
                          onInput={e => setInputFolder(e.target.value)}
                          onKeyDown={handleKeyDown}
                        />
                      </div>
                      <div className="nk-modal-action justify-end">
                        <ul className="btn-toolbar g-4 align-center">
                          <li><a href="# " className="link link-primary" onClick={handleCloseModal}>Bỏ qua</a></li>
                          <li><button className="btn btn-primary" onClick={handleClickSubmit} disabled={!inputFolder.length}> Đồng ý </button></li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </Fade>
          </Draggable>
        </Modal>
      </ul>
    </div>
  );
});

export default RenameFile;